export default __webpack_public_path__ + "assets/images/429c1ba8492d48831e2aee4a30e1e431.png";